"use strict";

var MARKUP_MARKER_TYPE = 0;
exports.MARKUP_MARKER_TYPE = MARKUP_MARKER_TYPE;
var ATOM_MARKER_TYPE = 1;
exports.ATOM_MARKER_TYPE = ATOM_MARKER_TYPE;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-text-renderer/dist/commonjs/mobiledoc-text-renderer/utils/marker-types.js
// module id = 1508
// module chunks = 0